import { PagedResponseEmpty } from "@ofqual/portal-core/core/types";
import { combineReducers, AnyAction } from "redux";
import {
  CREATING_LINKED_RECORD,
  LOADED_LINKEDRECORDS,
  LOADING_LINKEDRECORDS,
} from "./constants";
import { LinkedRecordsState, LinkedRecordStateDictionary } from "./state";

export const defaultLinkedRecordsFeedState: LinkedRecordsState = {
  params: {},
  status: "NOT_LOADED",
  response: PagedResponseEmpty,
  hasData: false,
};

export const defaultLinkedRecordsStateDictionary = {};

const linkedRecords = (
  state: LinkedRecordStateDictionary = defaultLinkedRecordsStateDictionary,
  action: AnyAction
): LinkedRecordStateDictionary => {
  const { type } = action;

  const getResourceIdAndState = () => {
    const resourceId: string = action.payload.resourceId;
    const thisResourceState = state[resourceId] || {
      ...defaultLinkedRecordsFeedState,
    };
    return { resourceId, thisResourceState };
  };

  switch (type) {
    case LOADING_LINKEDRECORDS: {
      const { resourceId, thisResourceState } = getResourceIdAndState();

      return {
        ...state,
        [resourceId]: {
          ...thisResourceState,
          status: "LOADING",
        },
      };
    }

    case LOADED_LINKEDRECORDS: {
      const { resourceId, thisResourceState } = getResourceIdAndState();

      return {
        ...state,
        [resourceId]: {
          ...thisResourceState,
          status: "LOADED",
          response: action.payload.response,
          hasData: true,
        },
      };
    }
    case CREATING_LINKED_RECORD: {
      const { resourceId, thisResourceState } = getResourceIdAndState();
      return {
        ...state,
        [resourceId]: {
          ...thisResourceState,
          status: "LOADING",
        },
      };
    }

    default:
      return state;
  }
};

export const rootReducer = combineReducers({
  linkedRecords,
});
